import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { menuAnatomy as parts } from "@chakra-ui/anatomy";

const msch = createMultiStyleConfigHelpers(parts.keys);

export default msch.defineMultiStyleConfig({
  // Styles for the base style
  baseStyle: {
    list: { zIndex: 4 },
  },
  // Styles for the size variations
  sizes: {},
  // Styles for the visual style variations
  variants: {
    quickFilter: {
      list: {
        width: "max-content",
        minWidth: "max-content",
        py: 1,
        borderColor: "gray.200",
        borderRadius: "md",
        boxShadow: "sm",
      },
      item: {
        px: 3,
        py: 1.5,
        fontSize: "sm",
        fontWeight: 400,
        whiteSpace: "nowrap",
        _focus: { backgroundColor: "gray.50" },
        _active: {
          backgroundColor: "magenta.dark",
          color: "white",
        },
        _checked: {
          backgroundColor: "lightPink",
          color: "white",
        },
      },
    },
  },
  // The default `size` or `variant` values
  defaultProps: {},
});
